
import Vue from "vue";
import { FIcon } from "@fkui/vue";

export default Vue.extend({
    name: "PrintButton",
    components: {
        FIcon,
    },
    methods: {
        printDoc(): void {
            window.print();
        },
    },
});
